module.exports = __webpack_public_path__ + "static/media/Resurs 270.42900482.png";